import { render } from "./BoardDetailMainContents.vue?vue&type=template&id=fdec60c6&scoped=true"
import script from "./BoardDetailMainContents.vue?vue&type=script&lang=js"
export * from "./BoardDetailMainContents.vue?vue&type=script&lang=js"

import "./BoardDetailMainContents.vue?vue&type=style&index=0&id=fdec60c6&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-fdec60c6"

export default script